// extracted by mini-css-extract-plugin
module.exports = {"text":"Meal_base_text__z5Cqe","benefitIcon":"Meal_base_benefitIcon__Jisw7","benefit":"Meal_base_benefit__1VS_9","checkmark":"Meal_base_checkmark__GFDcF"};